import axiosClient from "./axiosClient";

const userApi = {
  getAll: () => axiosClient.get("users"),
  update: (user) => axiosClient.put("users", user),
};

export default userApi;
